import React from 'react';
import i18n from 'i18next';
import isDate from 'utils/isDate';

import Box from 'components/Box';
import Card from 'components/Card';
import Flag from 'components/Flag';
import HintTooltip from 'components/HintTooltip';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Table, {Column} from 'components/Table';
import Time from 'components/Time';
import {NavLink} from 'react-router-dom';
import {
	AdminOrHubButtonLink,
	AdminOrHubTextLink,
} from 'components/AdminOrHubLink';

function MaybeLink({to, children}) {
	return to ? (
		<AdminOrHubTextLink link={to} as={NavLink}>
			{children}
		</AdminOrHubTextLink>
	) : (
		children
	);
}

/**
 * @deprecated This component is bonkers.
 * It's doing too much, and in a needlessly abstract way.
 *
 * TO DO: We should to refactor what data we're getting from the API in the
 * `inlineStatsPanel` components, and instead of loosely defining the
 * table based on the `cols` array and the order of keys in the data
 * objects, just render a Table directly and pass it through as `children`.
 */

export default function UserHistory({
	title,
	subtitle,
	data,
	cols,
	moreLink,
	onClose,
}) {
	const hasActionColumn = Boolean(data[0].action);
	const titleId = 'history-modal-title';
	return (
		<Modal
			onRequestClose={onClose}
			aria-labelledby={titleId}
			width={hasActionColumn ? 'extraWide' : 'wide'}
		>
			<Card variant="raised" overflow="visible">
				<ModalHeadline
					title={title}
					titleId={titleId}
					subtitle={subtitle}
					onClose={onClose}
				/>
				<Panel>
					<Box mx="-m">
						<Table
							data={data}
							getItemKey={item =>
								`${item.link || item.title}-${item.value}`
							}
							pl="m"
							pr="xs"
						>
							<Column
								title={cols[0]}
								cellRenderer={item => (
									<MaybeLink to={item.link}>
										<Flag
											token={
												item.icon && (
													<Icon
														vAlign
														name={item.icon}
													/>
												)
											}
											spacing="s"
										>
											{item.title}
										</Flag>
									</MaybeLink>
								)}
							/>
							{hasActionColumn && (
								<Column
									title={cols[1]}
									cellRenderer={item => item.action}
									width={1 / 4}
								/>
							)}
							<Column
								title={cols[hasActionColumn ? 2 : 1]}
								cellRenderer={item => {
									if (item.device && isDate(item.value)) {
										return (
											<>
												<Time dateTime={item.value} />
												<HintTooltip
													content={
														<>
															{item.device},
															<br />
															{new Date(
																item.value
															).toLocaleString()}
														</>
													}
													spacingLeft="xxs"
												/>
											</>
										);
									} else {
										return item.value;
									}
								}}
								width={1 / 4}
							/>
						</Table>
					</Box>
				</Panel>
				{moreLink && (
					<Panel align="center">
						<AdminOrHubButtonLink
							size="medium"
							variant="transparent"
							to={moreLink}
						>
							{i18n.t('actions_view_all')}
						</AdminOrHubButtonLink>
					</Panel>
				)}
			</Card>
		</Modal>
	);
}
